export default __webpack_public_path__ + "static/media/info.a244caa1.svg";